import React, { useEffect, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import Drawer from "@material-ui/core/Drawer";
import useStyles from "./styles";
import { useTheme, withStyles } from "@material-ui/core/styles";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Button from "@material-ui/core/Button";
import Logout from "../../../../../assets/images/logout.png";
import Typography  from "@material-ui/core/Typography";

export const StyledDrawer = withStyles((theme) => ({
  root: {
    position: "relative !important",
  },
  paperAnchorLeft: {
    width: "80%",
    height: "100vh",
    [theme.breakpoints.up("sm")]: {
      width: "50%",
    },
  },
}))((props) => <Drawer {...props} />);

const MobileNavDrawer = ({
  showDrawer = false,
  widgetList = [],
  setShowDrawer = () => {},
  contentArr = [],
  websiteData = {},
}) => {
  const classes = useStyles();
  let {
    isLoggedIn = false,
    userProfileData = {},
    handleLogout = () => {},
    deskTopView = true,
  } = websiteData || {};
  let { userName = "" } = userProfileData || {};
  let [{ component: LoginComponent = null } = {}] = widgetList.filter(
    (widget) => widget.id == "loginModal"
  );
  const [showLogin, setShowLogin] = useState(false);
  const [showKnowMore, setShowKnowMore] = useState(false);
  const [updatedContentArr, setUpdatedContentArr] = useState([]);
  const theme = useTheme();

  useEffect(() => {
    let newArr = [];
    let loginDropdownArr = contentArr.find((obj) => {
      return obj.id == "login";
    });
    let bookingObj = loginDropdownArr.dropDownItem.find((obj) => {
      return obj.id == "bookings";
    });
    let logoutObj = loginDropdownArr.dropDownItem.find((obj) => {
      return obj.id == "logout";
    });
    isLoggedIn && newArr.push(bookingObj);
    let arr = isLoggedIn
      ? contentArr.filter((obj) => obj.name != "Login")
      : contentArr;
    newArr = [...newArr, ...arr];
    isLoggedIn && newArr.push(logoutObj);
    setUpdatedContentArr(newArr);
  }, []);

  const LoginButton = () => {
    return (
      <Box ml={1}>
        <Button
          variant="outlined"
          style={{ width: "135px" }}
          className={classes.contentTextSideNavbar}
          onClick={() => setShowLogin(true)}
        >
          Login
        </Button>
      </Box>
    );
  };

  const DropDownType = ({ isBtn = false, items = [] }) => {
    let { name = "", link = "", id = "" } = items;
    if (link) {
      return (
        <a href={link} className={classes.contentTextSideNavbar}>
          {name.toUpperCase()}
        </a>
      );
    } else {
      return (
        <a className={classes.contentTextSideNavbar}>{name.toUpperCase()}</a>
      );
    }
  };

  const ReturnNavItem = ({
    isDropdown = false,
    deskTopView = true,
    isBtn = false,
    options = {},
    dropDownItem = [],
    id = "",
  }) => {
    if (id == "login") {
      return (
        <LoginButton deskTopView={deskTopView} dropDownItem={dropDownItem} />
      );
    }
    if (id == "logout") {
      return (
        <Box className={classes.navbarContentContainer}>
          {" "}
          <a onClick={handleLogout} className={classes.contentTextSideNavbar}>
            <img src={Logout} style={{ marginRight: 9, height: "20px" }} />
            <Typography>{options.name.toUpperCase()}</Typography>
          </a>
        </Box>
      );
    }
    if (isDropdown) {
      return (
        <Box display="flex" alignItems="start" flexDirection={"column"}>
          <Box
            onClick={() => setShowKnowMore(!showKnowMore)}
            className={classes.navbarContentContainer}
          >
            <a href={options.link} className={classes.contentTextSideNavbar}>
              {options.name}
            </a>
            <ArrowDropDownIcon style={{ marginTop: "15px" }} />
          </Box>
          <Box display={"flex"} flexDirection={"column"} ml={2}>
            {showKnowMore &&
              dropDownItem.map((items) => {
                let { isBtn = false } = items;
                return <DropDownType items={items} isBtn={isBtn} />;
              })}
          </Box>
        </Box>
      );
    } else {
      return (
        <Box className={classes.navbarContentContainer}>
          <a href={options.link} className={classes.contentTextSideNavbar}>
            {options.name}
          </a>
        </Box>
      );
    }
  };

  return (
    <>
      <StyledDrawer
        anchor="left"
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
      >
        <Box className={classes.mobileNavDrawer}>
          <Box display="flex" justifyContent="left" ml={1}>
            <IconButton
              className={classes.closeBtn}
              onClick={() => {
                setShowDrawer(false);
              }}
            >
              <CloseIcon style={{ color: theme.agentTheme.card.foreground }} />
            </IconButton>
          </Box>
          <Box>
            {
              <>
                {isLoggedIn && (
                  <Box
                    className={classes.navbarContentContainer}
                    display="flex"
                    alignItems="center"
                    ml={2}
                    mt={1.5}
                  >
                    <p class={classes.usernameText}> {`Hi ${userName}`} </p>
                  </Box>
                )}
                {!isLoggedIn
                  ? contentArr.map((item) => {
                      let {
                        isDropdown = false,
                        isBtn = false,
                        dropDownItem = [],
                        id = "",
                      } = item;
                      return (
                        <ReturnNavItem
                          deskTopView={deskTopView}
                          isDropdown={isDropdown}
                          isBtn={isBtn}
                          dropDownItem={dropDownItem}
                          options={item}
                          id={id}
                        />
                      );
                    })
                  : updatedContentArr.map((item) => {
                      let {
                        isDropdown = false,
                        isBtn = false,
                        dropDownItem = [],
                        id = "",
                      } = item;
                      return (
                        <ReturnNavItem
                          deskTopView={deskTopView}
                          isDropdown={isDropdown}
                          isBtn={isBtn}
                          dropDownItem={dropDownItem}
                          options={item}
                          id={id}
                        />
                      );
                    })}
              </>
            }
          </Box>
        </Box>
      </StyledDrawer>
      {showLogin && <LoginComponent onClose={() => setShowLogin(false)} />}
    </>
  );
};

export default MobileNavDrawer;
